<template>
  <div class="p-l-5 m-b-10">
    <table class="table_beauty condensed-alternate routing-plan-args">
      <thead>
        <tr class="bg-transparent">
          <th v-t="getRpcMessageTitle" />
        </tr> 
      </thead>
      <tbody>
        <tr
          v-for="(target, index) in parsedRpcDetail"
          :key="index"
          class="bg-transparent"
        >
          <div class="p-l-10">
            <td>
              {{ target.details }}
            </td>
          </div>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

const splitTargetsRegex = /(\r\n\t)/gm;

import messages from '../../locales';

export default {
  name: 'RpcCalculationSummary',

  props: {
    targets: {
      type: String,
      default: ''
    },
    columnName: {
      type: String,
      default: ''
    },
    columnDisplayName: {
      type: String,
      default: ''
    }
  },
  computed: {
    getRpcMessageTitle() {
      switch (this.columnName.toLowerCase()) { 
      case 'calculated':
        return this.$t('RPC_CALCULATION_DETAILS');
      case 'duplicate':
        return this.$t('RPC_DUPLICATE_DETAILS');
      case 'errored':
        return this.$t('RPC_ERROR_DETAILS');
      default:
        return '';
      }
    }
  },
  watch: {
    targets: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.parsedRpcDetail = this.parseRpcDetail(this.getTargetsFromString(newValue));
        }
      }
    }
  },
  methods: {
    getTargetsFromString(value) {
      //The string has a list of targets separated by the character \n 
      if (value.indexOf('\n') > -1) {
        return value.split('\n');
      } else {
        const targets = [];
        const splitString = value.split(splitTargetsRegex);
        for (let i = 0; i < splitString.length; i += 2) {
          if (splitString[i]) {
            targets.push(`${splitString[i]}${splitString[i + 1] ? splitString[i + 1] : ''}`.replace(/,$/, ''));
          }
        }

        return targets;
      }
    },
    parseRpcDetail(targets) {
      if (targets?.length) {
        return targets.map(target => {
          target.replace('\n', '');

          return {
            details: target,
          };
        });
      }

      return [];
    }
  },

  i18n: {
    locale: 'en',
    messages
  }
};
</script>